import React, { useState } from 'react';
import Icon from '../../../components/AppIcon';
import Button from '../../../components/ui/Button';

const UpgradeModal = ({ isOpen, onClose, onConfirm }) => {
  const [processing, setProcessing] = useState(false);
  const [paymentMethod, setPaymentMethod] = useState('credit_card');

  if (!isOpen) return null;

  const handleUpgrade = async () => {
    setProcessing(true);
    
    // Simulate payment processing delay
    await new Promise(resolve => setTimeout(resolve, 2000));
    
    await onConfirm();
    setProcessing(false);
  };

  return (
    <div className="fixed inset-0 bg-black/50 flex items-center justify-center z-50 p-4">
      <div className="bg-card rounded-xl shadow-2xl max-w-md w-full max-h-[90vh] overflow-y-auto">
        <div className="p-6">
          <div className="flex items-center justify-between mb-6">
            <h2 className="text-2xl font-bold text-foreground flex items-center gap-2">
              <Icon name="Crown" size={24} className="text-primary" />
              PRO Üyeliğe Yükselt
            </h2>
            <button
              onClick={onClose}
              disabled={processing}
              className="text-muted-foreground hover:text-foreground transition-colors"
            >
              <Icon name="X" size={24} />
            </button>
          </div>

          <div className="bg-gradient-to-br from-primary/10 to-secondary/10 rounded-lg p-6 mb-6">
            <div className="text-center mb-4">
              <div className="text-4xl font-bold text-primary mb-2">₺99</div>
              <div className="text-sm text-muted-foreground">/ ay</div>
            </div>
            
            <div className="space-y-3">
              <div className="flex items-start gap-2">
                <Icon name="Check" size={18} className="text-success mt-0.5" />
                <span className="text-sm text-foreground">Öncelikli etkinlik kayıtları</span>
              </div>
              <div className="flex items-start gap-2">
                <Icon name="Check" size={18} className="text-success mt-0.5" />
                <span className="text-sm text-foreground">%20 etkinlik indirimi</span>
              </div>
              <div className="flex items-start gap-2">
                <Icon name="Check" size={18} className="text-success mt-0.5" />
                <span className="text-sm text-foreground">Mağazada %15 indirim</span>
              </div>
              <div className="flex items-start gap-2">
                <Icon name="Check" size={18} className="text-success mt-0.5" />
                <span className="text-sm text-foreground">Reklamsız deneyim</span>
              </div>
              <div className="flex items-start gap-2">
                <Icon name="Check" size={18} className="text-success mt-0.5" />
                <span className="text-sm text-foreground">Özel PRO rozetleri</span>
              </div>
            </div>
          </div>

          <div className="mb-6">
            <label className="block text-sm font-semibold text-foreground mb-3">
              Ödeme Yöntemi
            </label>
            <div className="space-y-2">
              <label className="flex items-center gap-3 p-3 border border-border rounded-lg cursor-pointer hover:bg-muted/50 transition-colors">
                <input
                  type="radio"
                  name="payment"
                  value="credit_card"
                  checked={paymentMethod === 'credit_card'}
                  onChange={(e) => setPaymentMethod(e?.target?.value)}
                  className="w-4 h-4 text-primary"
                />
                <Icon name="CreditCard" size={20} className="text-muted-foreground" />
                <span className="text-sm text-foreground">Kredi Kartı</span>
              </label>
              <label className="flex items-center gap-3 p-3 border border-border rounded-lg cursor-pointer hover:bg-muted/50 transition-colors">
                <input
                  type="radio"
                  name="payment"
                  value="bank_transfer"
                  checked={paymentMethod === 'bank_transfer'}
                  onChange={(e) => setPaymentMethod(e?.target?.value)}
                  className="w-4 h-4 text-primary"
                />
                <Icon name="Building" size={20} className="text-muted-foreground" />
                <span className="text-sm text-foreground">Banka Havalesi</span>
              </label>
            </div>
          </div>

          <div className="bg-muted/50 rounded-lg p-4 mb-6">
            <div className="flex items-start gap-2 text-sm text-muted-foreground">
              <Icon name="Info" size={16} className="mt-0.5 flex-shrink-0" />
              <p>
                Bu demo bir ödeme simülasyonudur. Gerçek bir ödeme işlemi yapılmayacaktır.
              </p>
            </div>
          </div>

          <div className="flex gap-3">
            <Button
              variant="outline"
              size="default"
              onClick={onClose}
              disabled={processing}
              fullWidth
            >
              İptal
            </Button>
            <Button
              variant="default"
              size="default"
              onClick={handleUpgrade}
              disabled={processing}
              iconName={processing ? 'Loader' : 'Zap'}
              iconPosition="left"
              fullWidth
            >
              {processing ? 'İşleniyor...' : 'Üyeliği Yükselt'}
            </Button>
          </div>
        </div>
      </div>
    </div>
  );
};

export default UpgradeModal;